<template>
    <article class="content-page">
        <WatsonThemeQuoteFormUsps
            v-if="postTypes.quoteForm || postTypes.usps"
            :content="postTypes"
        />

        <WatsonOrganismContent
            class="content-container"
            :content="content"
        />
    </article>
</template>

<script setup>
import WatsonOrganismContent from '@organisms/content/watson-organism-content.vue';
import WatsonThemeQuoteFormUsps from '../../components/quote-form-usps/watson-theme-quote-form-usps.vue';

defineProps({
    page: {
        type: Object,
        required: true,
    },

    content: {
        type: Array,
        required: true,
    },

    postTypes: {
        type: Object,
        required: true,
    },
});
</script>

<style lang="scss" scoped>
@use 'content-index';
</style>
